'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate() {
}
export { $c_Lapp_api_PharmacyAppUpdate as $c_Lapp_api_PharmacyAppUpdate };
$c_Lapp_api_PharmacyAppUpdate.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate() {
}
export { $h_Lapp_api_PharmacyAppUpdate as $h_Lapp_api_PharmacyAppUpdate };
$h_Lapp_api_PharmacyAppUpdate.prototype = $c_Lapp_api_PharmacyAppUpdate.prototype;
$c_Lapp_api_PharmacyAppUpdate.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_api_PharmacyAppUpdate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_PharmacyAppUpdate)));
}
export { $isArrayOf_Lapp_api_PharmacyAppUpdate as $isArrayOf_Lapp_api_PharmacyAppUpdate };
//# sourceMappingURL=app.api.-Pharmacy-App-Update.js.map
